/* Voice for Valor — smt-vfv.js (v1.0.0)
   Launch-report events for the Voice for Valor page (launch-kit 06_TRACKING_AND_LINKS.md).
   Any element with data-vfv-event publishes that event name on click, plus
   vfv_scroll_50 / vfv_scroll_90 and vfv_apparel_view once each. Events go to
   Shopify's customer events (Shopify.analytics.publish: subscribe from a custom
   pixel) and to window.dataLayer when one exists. No UI, no dependencies. */
(function () {
  if (window.__vfvEvents) return;
  window.__vfvEvents = true;

  function send(name, detail) {
    var data = detail || {};
    data.page = 'voice-for-valor';
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-vfv-event]') : null;
    if (!el) return;
    send(el.getAttribute('data-vfv-event'), {
      href: el.getAttribute('href') || '',
      label: (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 90)
    });
  }, true);

  var marks = { 50: false, 90: false };
  function onScroll() {
    var h = document.documentElement;
    var seen = (window.scrollY + window.innerHeight) / Math.max(h.scrollHeight, 1);
    if (!marks[50] && seen >= 0.5) { marks[50] = true; send('vfv_scroll_50'); }
    if (!marks[90] && seen >= 0.9) { marks[90] = true; send('vfv_scroll_90'); window.removeEventListener('scroll', onScroll); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  function watchApparel() {
    var el = document.querySelector('[data-vfv-apparel]');
    if (!el || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { send('vfv_apparel_view'); io.disconnect(); return; }
      }
    }, { threshold: 0.3 });
    io.observe(el);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchApparel);
  else watchApparel();
})();